import type { IAddChatShareRecipientsBody } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

import { chatShareQueryKey } from "./chat-share.constants";

export const useAddChatShareRecipients = (chatUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: IAddChatShareRecipientsBody) =>
      chatApi.addChatShareRecipients(chatUuid, body),
    onSuccess: (data) => {
      queryClient.setQueryData(chatShareQueryKey(chatUuid), data);
    },
    // NOTE: ShareChatDialog owns its error toast (incl. the rate-limited case),
    // so suppress the global mutation-cache toast to avoid double toasts.
    meta: { suppressErrorToast: true },
  });
};
